export const sanitizeFileName = (fileName: string) => {
    const sanitizedFileName = fileName
        .replace(/\s+/g, '-') // Replace white spaces with '-'
        .replace(/[^a-zA-Z0-9-\u00C0-\u024F\u1E00-\u1EFF]/g, '');
    return sanitizedFileName;
};
